<template>
  <div class="signet-pc" id="signetPc">
    <!-- 导航 -->
    <Header type="pc" ref="newHeader" :addUseDialog="false" @showDialog="showDialog" />
    <!-- 头部导航“免费试用弹框” -->
    <UseDialog ref="dialog" />
    <!-- Banner -->
    <Banner
      :isPcFlag="isPcFlag"
      :pcBgImg="pcBgImg"
      :haveTheFormFlag="true"
      :bannerTitle="bannerTitle"
      bannerDesc="软硬协同，智慧办公"
      :landingPageName="landingPageName"
      @setShowSuccessDialog="setShowSuccessDialog"
    ></Banner>
    <!-- Form提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- Form 成功弹框 -->
    <SuccessForm v-if="showSuccessDialog" @closeform="showSuccessDialog = false" :isPcFlag="isPcFlag" />
    <!-- nav导航 -->
    <NavList :dataList="navList"></NavList>
    <!-- 产品介绍 -->
    <ProductIntroduction :dataList="productIntroductionList" :isPcFlag="isPcFlag"></ProductIntroduction>
    <!-- 产品优势 -->
    <ProductAdvantage :dataList="productAdvantageList" :isPcFlag="isPcFlag"></ProductAdvantage>
    <!-- 应用场景 -->
    <ApplicationScenarios :dataList="applicationScenariosList" :isPcFlag="isPcFlag"></ApplicationScenarios>
    <!-- 系统融合 -->
    <SystemIntegration :dataList="systemIntegrationList" :isPcFlag="isPcFlag"></SystemIntegration>
    <!-- 客户案例 -->
    <CustomerCase :dataList="customerCaseList" :isPcFlag="isPcFlag"></CustomerCase>
    <!-- 底部 -->
    <Footer type="pc" />
    <!--    &lt;!&ndash; 右侧导航 &ndash;&gt;-->
    <!--    <Contact :landingPageName="landingPageName" />-->
    <!-- 左侧计算机小象 -->
    <LeftBar />
  </div>
</template>

<script>
import dataList from './dataList'
export default {
  components: {
    LeftBar: () => import('@/components/LeftBar/index.vue'),
    Header: () => import('@/components/header/index.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    Banner: () => import('@/components/Banner.vue'),
    Footer: () => import('@/components/footer/index.vue'),
    // Contact: () => import('@/components/Contact.vue'),
    Message: () => import('@/components/Message.vue'),
    SuccessForm: () => import('@/components/SuccessForm.vue'),

    NavList: () => import('./components/NavList.vue'),
    ProductIntroduction: () => import('./components/ProductIntroduction.vue'),
    ProductAdvantage: () => import('./components/ProductAdvantage.vue'),
    ApplicationScenarios: () => import('./components/ApplicationScenarios.vue'),
    SystemIntegration: () => import('./components/SystemIntegration.vue'),
    CustomerCase: () => import('./components/CustomerCase.vue'),
  },
  data() {
    return {
      bannerTitle: '专注印章风控管理\u00a0\u00a0开启智能用印时代',
      isPcFlag: true,
      pcBgImg: require('@/assets/images/landing-signet/banner_bg.jpg'),
      navList: dataList.navList,
      productIntroductionList: dataList.productIntroductionList,
      productAdvantageList: dataList.productAdvantageList,
      applicationScenariosList: dataList.applicationScenariosList,
      systemIntegrationList: dataList.systemIntegrationList,
      customerCaseList: dataList.customerCaseList,
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      // 成功的弹框
      showSuccessDialog: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
    // 获取当前元素的父元素设置最小值
    const v = document.getElementById('signetPc').parentNode
    v.style.minWidth = '1320px'
  },

  methods: {
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= window.screen.height && scrollTop <= 2240
      if (scrollTop > 500) {
        document.getElementById('esign-header-wrapper').setAttribute('style', 'display: none')
      } else {
        document.getElementById('esign-header-wrapper').setAttribute('style', '')
      }
      this.$refs.newHeader && this.$refs.newHeader.scrollHandle()
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
  },
}
</script>

<style lang="less" scoped>
.signet-pc {
  padding-top: 60px;
}
</style>
<style lang="less">
* > img {
  max-width: 100%;
}

a {
  font-size: 1rem;
  color: #333;
}

a:hover,
input.error {
  color: #fa465a;
}

.container {
  width: 1200px\9;
}

@media (min-width: 1200px) {
  .main {
    min-width: 1200px;
  }
}

.banner,
.banner video,
.banner .text,
.banner .text .banner_tabbox .tab_listbox,
.con,
.con1,
.con1 .con1_tab .tab_box,
.con2,
.con2 .con2_tab .tab_box,
.con3,
.con4,
.con6,
.footer {
  min-width: 0;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
</style>
